import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [role, setRole] = useState('admin');

  // Simulated role toggle with local session storage
  const handleLogin = (e) => {
    e.preventDefault();
    localStorage.setItem('userRole', role); // Save role for robust access across pages
    
    if (role === 'admin') {
      navigate('/dashboard');
    } else {
      navigate('/jobs');
    }
  };

  return (
    <motion.div 
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
      className="w-full max-w-[360px] mx-auto"
    >
      <div className="text-left mb-10">
        <h5 className="text-[#11469A] text-xl font-bold mb-2">Welcome Back!</h5>
        <p className="text-[#878a99] text-sm">Sign in to continue to RM Ghana Portal.</p>
      </div>

      {/* Role Toggle for Demo */}
      <div className="flex bg-gray-100 p-1 rounded-lg mb-8">
        <button 
          onClick={() => setRole('admin')}
          className={`flex-1 py-2 text-xs font-bold uppercase tracking-wider rounded-md transition-all ${role === 'admin' ? 'bg-white text-[#11469A] shadow-sm' : 'text-gray-500'}`}
        >
          Admin
        </button>
        <button 
          onClick={() => setRole('candidate')}
          className={`flex-1 py-2 text-xs font-bold uppercase tracking-wider rounded-md transition-all ${role === 'candidate' ? 'bg-white text-[#11469A] shadow-sm' : 'text-gray-500'}`}
        >
          Candidate
        </button>
      </div>

      <form onSubmit={handleLogin} className="space-y-5">
        <div>
          <label className="block text-[13px] font-semibold text-[#212529] mb-2">Username</label>
          <input 
            type="text" 
            placeholder="Enter username" 
            className="w-full px-4 py-3 rounded border border-[#ced4da] focus:border-[#00AEEF] focus:ring-2 focus:ring-[#00AEEF]/20 outline-none transition-all placeholder:text-[#adb5bd] text-[13px]"
            defaultValue={role === 'admin' ? "admin" : "candidate123"}
            required
          />
        </div>
        
        <div>
          <div className="flex justify-between items-center mb-2">
            <label className="block text-[13px] font-semibold text-[#212529]">Password</label>
            <a href="#" className="text-[13px] text-[#878a99] hover:text-[#00AEEF] transition-colors">Forgot password?</a>
          </div>
          <div className="relative">
            <input 
              type={showPassword ? "text" : "password"} 
              placeholder="Enter password" 
              className="w-full px-4 py-3 rounded border border-[#ced4da] focus:border-[#00AEEF] focus:ring-2 focus:ring-[#00AEEF]/20 outline-none transition-all placeholder:text-[#adb5bd] text-[13px] pr-10"
              defaultValue="password123"
              required
            />
            <button 
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute inset-y-0 right-0 pr-3 flex items-center text-[#878a99] hover:text-[#495057]"
            >
              <SafeIcon name={showPassword ? "EyeOff" : "Eye"} size={16} />
            </button>
          </div>
        </div>

        <button 
          type="submit" 
          className="w-full bg-[#00AEEF] hover:bg-[#009bd6] text-white py-3 rounded font-semibold transition-all shadow-md mt-6 text-[13px] uppercase tracking-wider"
        >
          Sign In
        </button>
      </form>

      <div className="mt-10 text-left">
        <p className="text-[13px] text-[#878a99]">
          Don't have an account?{' '}
          <Link to="/signup" className="text-[#00AEEF] font-bold hover:underline decoration-2 underline-offset-4">
            Signup
          </Link>
        </p>
      </div>
    </motion.div>
  );
};

export default Login;